import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { QuoteFlowService } from '@services/quote-flow.service';
import { NAVIGATION_ROUTES } from '@shared/constants';

@Injectable({
  providedIn: 'root'
})
export class QuoteFlowGuard implements CanActivate {
  private router = inject(Router);
  private quoteFlowService = inject(QuoteFlowService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const url = route.routeConfig?.path || '';

    switch (url) {
      case 'quote-pre-list':
        return this.validateQuotePreListAccess();
      
      case 'quote-step-2':
        return this.validateQuoteStep2Access();
      
      case 'quote-estimation':
        return this.validateQuoteEstimationAccess();
      
      default:
        return true;
    }
  }

  /**
   * Valida el acceso a quote-pre-list
   * Requiere: tipos de trabajo seleccionados
   */
  private validateQuotePreListAccess(): boolean {
    const workTypesData = this.quoteFlowService.getSelectedWorkTypesData();
    const selectedConstructionTypes = this.quoteFlowService.getSelectedConstructionTypes();

    // Validar que existan tipos de trabajo seleccionados
    if (!workTypesData?.length && !selectedConstructionTypes?.length) {
      console.warn('QuoteFlowGuard: No work types selected, redirecting to home');
      this.router.navigate([NAVIGATION_ROUTES.ROOT]);
      return false;
    }

    return true;
  }

  /**
   * Valida el acceso a quote-step-2
   * Requiere: tipos de trabajo seleccionados y datos de pre-lista
   */
  private validateQuoteStep2Access(): boolean {
    const workTypesData = this.quoteFlowService.getSelectedWorkTypesData();
    const preListData = this.quoteFlowService.getPreListData();

    // Validar que existan tipos de trabajo seleccionados
    if (!workTypesData?.length) {
      console.warn('QuoteFlowGuard: No work types for step-2, redirecting to quote-pre-list');
      this.router.navigate([NAVIGATION_ROUTES.QUOTE_PRE_LIST]);
      return false;
    }

    // Validar que existan datos de pre-lista (se puede acceder sin items si vienen del pre-list)
    if (!preListData || (!preListData.items?.length && !preListData.selectedConstructionTypes?.length)) {
      console.warn('QuoteFlowGuard: No pre-list data for step-2, redirecting to quote-pre-list');
      this.router.navigate([NAVIGATION_ROUTES.QUOTE_PRE_LIST]);
      return false;
    }

    return true;
  }

  /**
   * Valida el acceso a quote-estimation  
   * Requiere: preListId válido
   */
  private validateQuoteEstimationAccess(): boolean {
    const preListId = this.quoteFlowService.getPreListId();
    const workTypesData = this.quoteFlowService.getSelectedWorkTypesData();

    // Validar que existe un preListId
    if (!preListId) {
      console.warn('QuoteFlowGuard: No preListId for estimation, redirecting to quote-step-2');
      this.router.navigate([NAVIGATION_ROUTES.QUOTE_STEP_2]);
      return false;
    }

    // Validar que existen tipos de trabajo (fallback adicional)
    if (!workTypesData?.length) {
      console.warn('QuoteFlowGuard: No work types for estimation, redirecting to quote-pre-list');
      this.router.navigate([NAVIGATION_ROUTES.QUOTE_PRE_LIST]);
      return false;
    }

    return true;
  }
}